const containerEls = document.querySelectorAll('[data-resourcelisting=main]');
if (containerEls) {

	//refresh page if 'back' is detected
	if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
		location.reload();
	  }

	const updateListing = (containerEl, formInputEls, moredivEl, page) => {
		const isReplacementContent = page === 0;
		const listEl = containerEl.querySelector('[data-resourcelisting=list]');
		const queryString = (() => {
			const filterData = [];
			for (let j = formInputEls.formCheckboxEls.length - 1; j >= 0; j -= 1) {
				if (formInputEls.formCheckboxEls[j].checked) {
					const { name, value } = formInputEls.formCheckboxEls[j];
					filterData.push(`${name}=${value}`);
				}
			}
			const categoryFilter = formInputEls.formCategoryEl;
			filterData.push(`${categoryFilter.name}=${categoryFilter.value}`);
			const searchFilter = formInputEls.formSearchEl;
			filterData.push(`${searchFilter.name}=${searchFilter.value}`);
			filterData.push(`page=${page}`);
			return filterData.join('&');
		})();
		const loadingClassName = `resourcelisting--${isReplacementContent ? 'loadnew' : 'loadmore'}`;
		containerEl.classList.add(loadingClassName);
		const xhr = new XMLHttpRequest();
		xhr.open('GET', `/resourcelisting.json?${queryString}`, true);
		xhr.onload = () => {
			if (xhr.status === 200) {
				if (isReplacementContent) {
					listEl.innerHTML = '';
				}
				const { posts, hasNextPage } = JSON.parse(xhr.response);
				for (let k = 0; k < posts.length; k += 1) {
					const itemEl = document.createElement('div');
					itemEl.setAttribute('class', 'resourcelisting-item');
					itemEl.innerHTML = posts[k];
					listEl.appendChild(itemEl);
				}

				if (hasNextPage) {
					moredivEl.removeAttribute('hidden');
				} else {
					moredivEl.setAttribute('hidden', true);
				}

				containerEl.classList.remove(loadingClassName);
			}
		};
		xhr.send();
	};
	for (let i = containerEls.length - 1; i >= 0; i -= 1) {
		let page = 0;
		const containerEl = containerEls[i];
		const formEl = containerEl.querySelector('[data-resourcelisting=form]');
		const formSearchEl = formEl.querySelector('[data-resourcelisting=search]');
		const formCategoryEl = formEl.querySelector('[data-resourcelisting=category]');
		const formCheckboxEls = formEl.querySelectorAll('[data-resourcelisting=checkbox]');
		const formSelectEl = formEl.querySelector('[data-resourcelisting=select]');
		const moredivEl = containerEl.querySelector('[data-resourcelisting=morediv]');
		const morebuttonEl = moredivEl.querySelector('[data-resourcelisting=morebutton]');
		const formInputEls = {
			formSearchEl, formCheckboxEls, formSelectEl, formCategoryEl,
		};
		const clearUpdateListing = () => {
			page = 0;
			updateListing(containerEl, formInputEls, moredivEl, 0);
		};
		formEl.addEventListener('submit', (e) => {
			e.preventDefault();
			clearUpdateListing();
		});
		formSearchEl.addEventListener('change', clearUpdateListing);
		formSearchEl.addEventListener('keydown', (e) => {
			if (e.keyCode === 13) {
				clearUpdateListing();
				e.target.blur();
			}
		});
		for (let j = formCheckboxEls.length - 1; j >= 0; j -= 1) {
			formCheckboxEls[j].addEventListener('change', clearUpdateListing);
		}
		formSelectEl.addEventListener('change', () => {
			for (let j = formCheckboxEls.length - 1; j >= 0; j -= 1) {
				const isSelected = !formSelectEl.value || formCheckboxEls[j].name === formSelectEl.value;
				formCheckboxEls[j].checked = isSelected;
			}
			clearUpdateListing();
		});
		morebuttonEl.addEventListener('click', () => {
			els = document.getElementsByClassName('resourcelisting-item');
			el = els[els.length - 1];
			page += 1;
			updateListing(containerEl, formInputEls, moredivEl, page);
			el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
		});
	}
}
